import every from 'lodash/every';
import find from 'lodash/find';
import React from 'react';

import ImageWithText from './image-with-text';

import LinkWithText from './link-with-text';
import {FormattedTime, useIntl} from 'react-intl';

const Event = function ({
	tags,
	isExpanded,
	eventPredicates,
	event,
	itemClassName,
	prefixClassName,
	feature,
}) {
	const intl = useIntl();

	const isVisible = every(eventPredicates, (predicate) =>
		predicate(event, feature)
	);
	const tag = find(tags, (t) => t.id === event.tag_ids.split(',')[0]);
	const tagGroupId = tag?.tagGroupId;

	return (
		<li
			className={`${itemClassName} ${
				itemClassName + '--category' + tagGroupId
			}  ${!isVisible ? itemClassName + '--hidden' : ''}`}
		>
			<div className={prefixClassName('time')}>
				<span
					title={intl.formatDate(event.datetime_from, {
						day: 'numeric',
						month: 'numeric',
						year: 'numeric',
						hour: '2-digit',
						minute: '2-digit',
					})}
				>
					<FormattedTime
						value={event.datetime_from}
						hour="2-digit"
						minute="2-digit"
					/>
				</span>
				{event.datetime_to && (
					<>
						{' — '}
						<span
							title={intl.formatDate(event.datetime_to, {
								day: 'numeric',
								month: 'numeric',
								year: 'numeric',
								hour: '2-digit',
								minute: '2-digit',
							})}
						>
							<FormattedTime
								value={event.datetime_to}
								hour="2-digit"
								minute="2-digit"
							/>
						</span>
					</>
				)}
				{isExpanded && ' Uhr'}
			</div>

			<div className={prefixClassName('title')}>
				{event.title}

				{event.subtitle && (
					<span className={prefixClassName('subtitle')}>
						{event.subtitle}
					</span>
				)}

				<span className={prefixClassName('tags')}>
					{event.tag_names && event.tag_names.split(',').join(', ')}
				</span>
			</div>

			{isVisible && isExpanded && (
				<div className={prefixClassName('image-wrapper')}>
					<div className={prefixClassName('image-wrapper__inner')}>
						<ImageWithText
							image={event.image}
							text={event.image_text}
							prefixClassName={prefixClassName}
						/>
					</div>
				</div>
			)}

			{isVisible && isExpanded && (
				<p className={prefixClassName('description')}>
					<span
						dangerouslySetInnerHTML={{__html: event.description}}
					/>

					{event.web && (
						<LinkWithText
							className={prefixClassName('link')}
							target="_blank"
							rel="external"
							link={event.web}
							textFallback="Zur Website"
						/>
					)}
				</p>
			)}
		</li>
	);
};

export default Event;
